import AboutItem from "../AboutItem";
import laptopOverShotImage from "../../../../../assets/img/other/LaptopOverShot.jpg";

export default function DeliverOnTime() {
    return (
        <AboutItem
            heading="Built by our team. Developed with our customers."
            thumbnail={laptopOverShotImage}
            floatingIcon={
                <div className="zindex-1 d-none d-lg-block position-absolute top-0 start-0 translate-middle-x w-auto pt-3 mt-5">
                    <div data-aos="fade-up" data-aos-duration="950" data-aos-offset="280" className="aos-init">
                        <svg className="text-primary" width="160" height="160" viewBox="0 0 160 160" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="80" cy="80" r="80"></circle>
                        </svg>
                    </div>
                </div>
            }
        >
            {/* 
        
                <div id="about-side-by-side">
                    <div style={{ width: "25ch" }}>
                        <div className="text-muted mb-2">01</div>
                        <h3 className="h5">Individual approach</h3>
                        <p className="mb-0">Hac erat leo proin odio est sed sit in felis facilisi integer sed congue neque turpis dictumst sitsed volutpat aliquet tortor.</p>
                    </div>
                    <div style={{ width: "25ch", marginLeft: "7.5%" }}>
                        <div className="text-muted mb-2">02</div>
                        <h3 className="h5">Integrated analytics</h3>
                        <p className="mb-0">Find aute irure dolor in enderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur neque congue neque turpis.</p>
                    </div>
                </div>
        
            */}
            <div className="about-copy">
                <p>
                    We develop equi-track ourselves. Our in-house team brings over 20 years of bespoke software experience and a continual focus on innovation.
                </p>
                <p>
                    Every customer becomes part of our feedback loop. Your ideas and operational challenges help shape what we build next, and every suggestion is considered by the people developing the system.
                </p>
                <p>
                    We can also discuss customisations and integrations to support your business processes.
                </p>
            </div>
        </AboutItem>
    )
}
